<div class="customer-detail-root">
  <div id="business-header-content" class="header">
    <div class="left-header">
      <app-photo-name [businessSummary]="businessSummary"></app-photo-name>
    </div>
    <div class="right-header">
      <app-customer-detail-selector ></app-customer-detail-selector>
    </div>

  </div>
  
  <div class="container">
    <ng-template [ngIf]="detail === 'summary'">
      <app-customer-summary [businessId]="businessId" [viewOnly]="viewOnly"
                            [viewOnly]="viewOnly"
                            (businessUpdated)="reloadBusinessSummary()"></app-customer-summary>
    </ng-template>
    <ng-template [ngIf]="detail === 'points' && businessSummary">
      <app-customer-points [businessSummary]="businessSummary" [businessId]="businessId" [viewOnly]="viewOnly"></app-customer-points>
    </ng-template>
    <ng-template [ngIf]="detail === 'products'">
      <app-customer-printers [businessId]="businessId" [viewOnly]="viewOnly"></app-customer-printers>
    </ng-template>
    <ng-template [ngIf]="detail === 'coupons'">
      <app-customer-detail-coupons [businessId]="businessId"></app-customer-detail-coupons>
    </ng-template>
  </div>
</div>
